import React from 'react';
import { Link } from 'react-router-dom';
import { SearchX, ArrowRight } from 'lucide-react';
import Seo from '../common/Seo';

/**
 * 404-Seite fuer unbekannte Routen.
 * noindex verhindert, dass Google Muell-URLs als Soft-404 indexiert;
 * serve.php liefert fuer unbekannte Pfade zusaetzlich den echten HTTP-404-Status.
 */
const NotFound = () => (
  <div className="container mx-auto px-4 py-8">
    <Seo
      title="Seite nicht gefunden | SportyReplay"
      description="Diese Seite existiert nicht mehr oder wurde verschoben. Stöbere stattdessen durch alle gebrauchten Sportartikel bei SportyReplay."
      noindex
    />

    <div className="max-w-2xl mx-auto text-center py-12">
      <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gray-100 mb-6">
        <SearchX className="w-10 h-10 text-orange-500" />
      </div>

      <p className="text-sm font-semibold tracking-widest text-orange-500 mb-2">FEHLER 404</p>
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
        Diese Seite gibt es nicht (mehr)
      </h1>
      <p className="text-gray-500 leading-relaxed mb-10">
        Vielleicht wurde das Angebot bereits verkauft oder der Link ist veraltet.
        Diese Seiten helfen dir weiter:
      </p>

      <div className="grid sm:grid-cols-3 gap-4 text-left">
        {[
          { to: '/', label: 'Startseite', desc: 'Neueste Angebote' },
          { to: '/products', label: 'Alle Produkte', desc: 'Nach Verein filtern' },
          { to: '/fuer-vereine', label: 'Für Vereine', desc: 'So funktioniert es' },
        ].map(({ to, label, desc }) => (
          <Link
            key={to}
            to={to}
            className="group bg-white border border-gray-200 rounded-xl p-5 hover:border-orange-400 hover:shadow-md transition-all"
          >
            <div className="flex items-center justify-between mb-1">
              <span className="font-semibold text-gray-800">{label}</span>
              <ArrowRight className="w-4 h-4 text-gray-300 group-hover:text-orange-500 group-hover:translate-x-0.5 transition-all" />
            </div>
            <span className="text-sm text-gray-500">{desc}</span>
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export default NotFound;
